import { push } from "connected-react-router";
import { useCallback, useState } from "react";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import {
  APPLICATION_MODE_NEW,
  DOCUMENT_CONTENT_TYPE_PDF,
  DOCUMENT_TYPE_CRIMINAL_RECORD,
  // DOCUMENT_TYPE_BROKER_COURSE_CERTIFICATE,
  // DOCUMENT_TYPE_EDUCATION_CERTIFICATE,
  // DOCUMENT_TYPE_WORK_EXPERIENCE,
  ROUTE_PATH,
  VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT
} from "../../../app/constants";
import {
  Header,
  Button,
  Paragraph,
  ErrorMark,
  SubSeparator
} from "../../../components/RegularComponents";
import ReviewForm from "../../../components/ReviewForm/ReviewForm";
import TopNavigationBar from "../../TopNavigationBar";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import { ERROR_STRING } from "../../../app/errors";
import {
  applicationTypeFromLicenceSubType
  // entityNameFromEntityId
} from "../../../redux/slice/applicationsUtils";
import { AgentContactInformation } from "./AgentContactInformation";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import {
  DocumentViewerFileNameLink,
  DownloadFileNameLink
} from "../../../components/DocumentViewer/DocumentFileComponent";
import { convertFileDataForUrl } from "../../../app/documentUploadUtils";
import { fetchDocumentData } from "../../../redux/slice/supportingDocumentsSlice";
import DocumentViewer from "../../../components/DocumentViewer/DocumentViewer";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";
import {
  // LICENCED_EXEMPT,
  // LICENCED_UNDER_BROKERAGE,
  setMainAgentRetentionApplicationForApproval,
  // setMortgageProperty
} from "../../../redux/slice/primaryAgencyApplicationSlice";
import { fullName } from "../../../app/utils";
import { MainAgentCriminalRecordCheckUpload } from "./MainAgentCriminalRecordCheckUpload";
import { MainAgentNSLicenceNumber } from "./MainAgentNSLicenceNumber";
// import { MainAgentLicenceNumber } from "./MainAgentLicenceNumber";
// import { MainAgentMortgageBrokerInfo } from "./MainAgentMortgageBrokerInfo";
// import { MainAgentUploadWorkHistory } from "./MainAgentUploadWorkHistory";

// const MORTGAGE_APPLICATION_PROPERTY = "userApplicationReviewComplete";

export const AgentApplicationReview = (props) => {
  const dispatch = useDispatch();
  const { application } = usePathApplication();
  const isPrincipalBroker = ROUTE_PATH.PB_APP.search(application) !== -1;
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  // const agencyApplication = useSelector(currentAgentApplicationSelector);
  const { agencyApplication } = useSelector(agencyApplicationSelector) || {};
  const documents = agencyApplication?.documents;
  const licencingSubType = agencyApplication?.licencingSubType;
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
  const applicationMode = APPLICATION_MODE_NEW;

  const businessLicenceData = agencyApplication?.businessLicenceData ?? {};

  const {
    personData,
    // previouslyLicencedStatus,
    // mblraLicenceNumber,
    // licenceHistoryData,
    // confirmCompletionRegulatoryInfo,
    // confirmRequiredCourseCompletion,
    // hasRequiredEducationQualification,
    // confirmEducationQualificationCompletion,
    // licenceAnotherProvince,
    // workHistoryData
    mraNSLicenceNumber,
    currentlyMBinBusiness
  } = businessLicenceData;

  const [editComponent, setEditComponent] = useState(null);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [openDocumentViewer, setOpenDocumentViewer] = useState(false);
  const [documentViewerDocument, setDocumentViewerDocument] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const COMPONENT_KEYS = {
    APPLICANT_NAME: "applicantName",
    APPLICANT_CONTACT: "applicantContact",
    CURRENT_MORTGAGE_LICENCE: "currentMortgageLicence",
    CRC_DOCUMENT_UPLOAD: "crcDocumentUpload",
    BROKER_EDUCATION: "brokerEducation",
    CURRENT_NS_LICENCE: "currentNSLicence"
  };

  const uploadCriminalRecordCheck = documents?.filter(
    (document) =>
      document.documentType === DOCUMENT_TYPE_CRIMINAL_RECORD && document.changeType !== "DELETE"
  );

  /*
  const previousLicenceReviewData = useMemo(() => {
    const textMapping = {
      LICENCED_INDIVIDUAL: "Mortgage Broker Licence",
      LICENCED_UNDER_BROKERAGE: `Mortgage Broker Licence`,
      LICENCED_EXEMPT:
        "Mortgage Broker Licence - you brokered mortgages for a federally regulated financial institution for at least 24 out of the last 36 months immediately before the date of your application.",
      NOT_LICENCED: "Associate Mortgage Broker Licence"
    };

    return {
      "What type of licence are you applying for?": textMapping[previouslyLicencedStatus] ?? ""
    };
  }, [previouslyLicencedStatus]);
  */

  const documentReviewComponent = useCallback(
    (file) => {
      const fileComponents = [];

      if (file.documentContentType === DOCUMENT_CONTENT_TYPE_PDF) {
        fileComponents.push(
          <div style={{ maxWidth: "40rem", overflow: "hidden" }}>
            <DocumentViewerFileNameLink
              id={"document-view-link-" + file.fileName}
              key={"document-view-link-" + file.fileName}
              file={file}
              onClick={() => {
                if (file.data) {
                  let fileDataUrl = convertFileDataForUrl(file.data, file.documentContentType);
                  setDocumentViewerDocument(fileDataUrl);
                  setSelectedFile(file);
                  setOpenDocumentViewer(true);
                } else {
                  // download file data and then show it
                  dispatch(fetchDocumentData(file.guid))
                    .then((downloadFile) => {
                      if (downloadFile) {
                        let fileDataUrl = convertFileDataForUrl(
                          downloadFile.data,
                          downloadFile.documentContentType
                        );
                        setDocumentViewerDocument(fileDataUrl);
                        setSelectedFile(downloadFile);
                        setOpenDocumentViewer(true);
                      }
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                }
              }}
            />
          </div>
        );
      } else {
        fileComponents.push(
          <DownloadFileNameLink
            id={"download-link-" + file.fileName}
            componentKey={"download-link-" + file.fileName}
            file={file}
          />
        );
      }

      return fileComponents;
    },
    [dispatch]
  );

   /*
  const workHistoryReviewData = useMemo(() => {
    const historyDetails = (history) => {
      return {
        "Start date": humanReadableDate(history.startDate),
        Duration: history.duration ?? "",
        Description: history.description ?? ""
      };
    };

   
    const HistoryComponents = workHistoryData?.map((workHistory, index) => {
      return (
        <>
          <ReviewForm fullSize data={historyDetails(workHistory)} />
          {index < workHistoryData?.length - 1 && <SubSeparator />}
        </>
      );
    });

    const experienceLetters = documents?.filter(
      (d) => d.documentType === DOCUMENT_TYPE_WORK_EXPERIENCE && d.changeType !== "DELETE"
    );
    const ExpLetterComponents = experienceLetters?.map((d, index) => {
      return (
        <>
          <ReviewForm
            fullSize
            data={{
              "Uploaded document": documentReviewComponent(d)
            }}
          />
          {index < experienceLetters.length - 1 && <SubSeparator />}
        </>
      );
    });

    return (
      <>
        {HistoryComponents}
        {ExpLetterComponents}
      </>
    );
  }, [workHistoryData, documents, documentReviewComponent]);
  */

  /*
  const brokerCourseReviewData = useMemo(() => {
    const descText = `I confirm that I will complete the Nova Scotia Mortgage Broker course before the date my new licence expires`;
    const brokerCourseDocuments = documents?.filter(
      (d) => d.documentType === DOCUMENT_TYPE_BROKER_COURSE_CERTIFICATE && d.changeType !== "DELETE"
    );
    const BrokerCourseCertificateComponents = brokerCourseDocuments?.map((d, index) => {
      return (
        <>
          <ReviewForm
            fullSize
            data={{
              "Uploaded document": documentReviewComponent(d)
            }}
          />
          {index < brokerCourseDocuments.length - 1 && <SubSeparator />}
        </>
      );
    });
    return (
      <>
        <ReviewForm
          fullSize
          data={{
            [descText]: confirmRequiredCourseCompletion ? "Yes" : "No"
          }}
        />
        {BrokerCourseCertificateComponents}
      </>
    );
  }, [confirmRequiredCourseCompletion, documents, documentReviewComponent]);
  */

  const MainSeparator = () => {
    return (
      <hr className="bottomMarginNormal" style={{ borderColor: "#777", borderWidth: "3px" }} />
    );
  };

  /*
  const educationCertificateReviewData = useMemo(() => {
    const k1 = "Has the applicant completed the education requirement?";

    let reviewData = {};

    const addProperty = (obj, k, v) => {
      return Object.defineProperty(obj, k, {
        value: v,
        enumerable: true,
        writable: true
      });
    };

    if (licenceAnotherProvince) {
      reviewData = addProperty(
        reviewData,
        k1,
        "The Requirement is exempt since this applicant has a current Mortgage Broker Licence from an exempt province."
      );
    } else {
      if (!hasRequiredEducationQualification) {
        if (confirmEducationQualificationCompletion) {
          reviewData = addProperty(
            reviewData,
            k1,
            "No, the principal broker confirmed the applicant will complete the requirement within 1 year."
          );
        } else {
          reviewData = addProperty(reviewData, k1, "No");
        }
      } else {
        const educationCertificates = documents?.filter(
          (document) =>
            document.documentType === DOCUMENT_TYPE_EDUCATION_CERTIFICATE &&
            document.changeType !== "DELETE"
        );
        if (educationCertificates?.length) {
          educationCertificates.forEach((cert) => {
            const fileC = documentReviewComponent(cert);
            reviewData = addProperty(reviewData, "Uploaded certificate", fileC);
          });
        } else {
          reviewData = addProperty(reviewData, "Uploaded certificate", "");
        }
      }
    }

    return reviewData;
  }, [
    hasRequiredEducationQualification,
    confirmEducationQualificationCompletion,
    licenceAnotherProvince,
    documents,
    documentReviewComponent
  ]);
  */

  const titleForComponent = (componentKey) => {
    switch (componentKey) {
      case COMPONENT_KEYS.APPLICANT_NAME:
        return "Applicant Name";
      case COMPONENT_KEYS.APPLICANT_CONTACT:
        return "Applicant Contact";
      case COMPONENT_KEYS.CURRENT_MORTGAGE_LICENCE:
        return "Current Mortgage Licence";
      case COMPONENT_KEYS.CRC_DOCUMENT_UPLOAD:
        return "Criminal Record Check Upload";
      case COMPONENT_KEYS.BROKER_EDUCATION:
        return "Applicant Education";
      default:
        return "";
    }
  };

  /*=== click handlers == */
  // const handleEditBrokerApplicant = () => {
  //   setShowEditDialog(true);
  //   setEditComponent(COMPONENT_KEYS.APPLICANT_NAME);
  // };

  const handleEditBrokerContact = () => {
    setShowEditDialog(true);
    setEditComponent(COMPONENT_KEYS.APPLICANT_CONTACT);
  };

  // const handleEditBrokerEducation = () => {
  //   setShowEditDialog(true);
  //   setEditComponent(COMPONENT_KEYS.BROKER_EDUCATION);
  // };

  // const handleEditCurrentLicenceInformation = () => {
  //   setShowEditDialog(true);
  //   setEditComponent(COMPONENT_KEYS.CURRENT_MORTGAGE_LICENCE);
  // };

  const handleEditCriminalRecord = () => {
    setShowEditDialog(true);
    setEditComponent(COMPONENT_KEYS.CRC_DOCUMENT_UPLOAD);
  };

  const handleCurrentNSLicenceNumber = () => {
    setShowEditDialog(true);
    setEditComponent(COMPONENT_KEYS.CURRENT_NS_LICENCE);
  }

  let stepCounter = 1;

  return (
    <>
      <div className={"container"}>
        <TopNavigationBar
          {...props}
          applicationType={applicationType}
          applicationMode={applicationMode}
        />
        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Header id="broker-application-review-header" header="Application Review" />
            <Paragraph
              id="broker-application-review-text"
              text={["Please review and ensure the information you have provided is correct."]}
            />
          </div>
        </div>

        <div className="timeline row">
          <ol>
            <li className="timeline-item col-md-12">
              <div className="step-content col-md-12 col-xs-12">
                <span className="step-counter step-counter-circle">{stepCounter++}</span>
                <div className="row">
                  <div className="col-lg-11">
                    <Paragraph
                      style={{ paddingTop: "10px" }}
                      id="broker-application-review-text"
                      text={["<h3>Applicant Information</h3>"]}
                    />
                    <ReviewForm
                      fullSize
                      data={{
                        "Full name": fullName(personData),
                        "Home Address": personData?.addressData?.address1 ?? "",
                        "City/Town": personData?.addressData?.cityName ?? "",
                        Province: personData?.addressData?.stateName ?? "",
                        "Postal code": personData?.addressData?.postalCode ?? "",
                        "Phone number": personData?.phoneNumber ?? "",
                        "Alternate phone number": personData?.alternatePhoneNumber ?? "",
                        Email: personData?.email ?? ""
                      }}
                    />
                  </div>
                  <div className="col-lg-1">
                    <Button
                      style={{ marginTop: "10px" }}
                      buttonType={"regular_primary"}
                      text={"Edit"}
                      onClick={handleEditBrokerContact}
                    />
                  </div>
                </div>
              </div>
            </li>

            {/* previouslyLicencedStatus && (
              <li className="timeline-item col-md-12">
                <div className="step-content col-md-12 col-xs-12">
                  <MainSeparator />
                  <span className="step-counter step-counter-circle">{stepCounter++}</span>
                  <div className="row">
                    <div className="col-lg-11">
                      <Paragraph
                        style={{ paddingTop: "10px" }}
                        id="broker-application-review-text"
                        text={[
                          `<h3>${
                            previouslyLicencedStatus === LICENCED_EXEMPT
                              ? "Work History and Mortgage Broker Course"
                              : "Current Mortgage Broker Licences"
                          }</h3>`
                        ]}
                      />
                      <ReviewForm fullSize data={previousLicenceReviewData} />
                      {previouslyLicencedStatus === LICENCED_EXEMPT && (
                        <div className="row">
                          <SubSeparator />
                          <div className="col-lg-11">
                            <Paragraph
                              style={{ paddingTop: "10px" }}
                              id="broker-application-review-text"
                              text={["<h3>Work history<h3>"]}
                            />
                            {workHistoryReviewData}
                          </div>
                          <SubSeparator />
                          <div className="col-lg-11">
                            <Paragraph
                              style={{ paddingTop: "10px" }}
                              id="broker-application-review-text"
                              text={["<h3>Nova Scotia Mortgage Broker Course<h3>"]}
                            />
                            {brokerCourseReviewData}
                          </div>
                        </div>
                      )}

                      {previouslyLicencedStatus === LICENCED_UNDER_BROKERAGE && (
                        <>
                          <SubSeparator />
                          <div className="row">
                            <div className="col-lg-11">
                              <Paragraph
                                style={{ paddingTop: "10px" }}
                                id="broker-application-review-text"
                                text={["<h4>Licences from exempt provinces?</h4>"]}
                              />
                              <ReviewForm
                                fullSize
                                data={{
                                  "Have current mortgage broker licence from the exempt provinces?":
                                    licenceAnotherProvince ? "Yes" : "No"
                                }}
                              />
                            </div>
                          </div>

                          {licenceAnotherProvince && (
                            <>
                              <SubSeparator />
                              <div className="row">
                                <div className="col-lg-11">
                                  <Paragraph
                                    style={{ paddingTop: "10px" }}
                                    id="broker-application-review-text"
                                    text={["<h4>Licence details from exempt provinces</h4>"]}
                                  />
                                  <ReviewForm
                                    fullSize
                                    data={{
                                      Province: licenceHistoryData?.province ?? "",
                                      "Licence number": licenceHistoryData?.licenceNumber ?? "",
                                      "Expiry date": licenceHistoryData?.endDate
                                        ? humanReadableDate(licenceHistoryData?.endDate)
                                        : ""
                                    }}
                                  />
                                </div>
                              </div>
                            </>
                          )}

                          {!licenceAnotherProvince && (
                            <>
                              <SubSeparator />
                              <div className="row">
                                <div className="col-lg-11">
                                  <Paragraph
                                    style={{ paddingTop: "10px" }}
                                    id="broker-application-review-text"
                                    text={[
                                      "<h4>Provide your associate mortgage broker licence number under MRA</h4>"
                                    ]}
                                  />
                                  <ReviewForm
                                    fullSize
                                    data={{
                                      "Licence number": mblraLicenceNumber ?? ""
                                    }}
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                    <div className="col-lg-1">
                      <Button
                        style={{ marginTop: "10px" }}
                        buttonType={"regular_primary"}
                        text={"Edit"}
                        onClick={handleEditCurrentLicenceInformation}
                      />
                    </div>
                  </div>
                </div>
              </li>
            )*/}

            {/* isPrincipalBroker && (
              <li className="timeline-item col-md-12">
                <div className="step-content col-md-12 col-xs-12">
                  <MainSeparator />
                  <span className="step-counter step-counter-circle">{stepCounter++}</span>
                  <div className="row">
                    <div className="col-lg-11">
                      <Paragraph
                        style={{ paddingTop: "10px" }}
                        id="broker-application-review-text"
                        text={["<h3>Education</h3>", "<h4>Regulatory Information Program</h4>"]}
                      />
                      <ReviewForm
                        fullSize
                        data={{
                          "Completion of the Regulatory Information Program":
                            confirmCompletionRegulatoryInfo ? "Yes" : "No"
                        }}
                      />
                      {previouslyLicencedStatus === LICENCED_UNDER_BROKERAGE && (
                        <>
                          <SubSeparator />
                          <div className="row">
                            <div className="col-lg-11">
                              <Paragraph
                                style={{ paddingTop: "10px" }}
                                id="broker-application-review-text"
                                text={[`<h4>Nova Scotia Mortgage Broker Education Program</h4>`]}
                              />
                              <ReviewForm fullSize data={educationCertificateReviewData} />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="col-lg-1">
                      <Button
                        style={{ marginTop: "10px" }}
                        buttonType={"regular_primary"}
                        text={"Edit"}
                        onClick={handleEditBrokerEducation}
                      />
                    </div>
                  </div>
                </div>
              </li>
            ) */}

            {!isPrincipalBroker && <li className="timeline-item col-md-12">
              <div className="step-content col-md-12 col-xs-12">
                <MainSeparator />
                <span className="step-counter step-counter-circle">{stepCounter++}</span>
                <div className="row">
                  <div className="col-lg-11">
                    <Paragraph
                      style={{ paddingTop: "10px" }}
                      id="broker-application-review-text"
                      text={["<h3>Criminal Record</h3>"]}
                    />
                    {Array.isArray(uploadCriminalRecordCheck) &&
                      uploadCriminalRecordCheck.map((element, index) => (
                        <>
                          <ReviewForm
                            fullSize
                            data={{
                              File: documentReviewComponent(element)
                            }}
                          />
                          {index < uploadCriminalRecordCheck.length - 1 && <SubSeparator />}
                        </>
                      ))}
                  </div>
                  <div className="col-lg-1">
                    <Button
                      style={{ marginTop: "10px" }}
                      buttonType={"regular_primary"}
                      text={"Edit"}
                      onClick={handleEditCriminalRecord}
                    />
                  </div>
                </div>
              </div>
            </li>}

            { isPrincipalBroker &&
            <li className="timeline-item col-md-12">
              <div className="step-content col-md-12 col-xs-12">
                <MainSeparator />
                <span className="step-counter step-counter-circle">{stepCounter++}</span>
                <div className="row">
                  <div className="col-lg-11">
                    <Paragraph
                      style={{ paddingTop: "10px" }}
                      id="broker-application-review-text"
                      text={["<h3>Current Nova Scotia License</h3>"]}
                    />
                    <ReviewForm
                      fullSize
                      data={{
                        "Mortgage Broker Licence Number": mraNSLicenceNumber ?? "- - - -",
                        "Are you currently a mortgage broker on the business for which you are applying to be the Principal Broker?" : currentlyMBinBusiness ? "Yes" : "No"
                      }}
                    />
                  </div>
                  <div className="col-lg-1">
                    <Button
                      style={{ marginTop: "10px" }}
                      buttonType={"regular_primary"}
                      text={"Edit"}
                      onClick={handleCurrentNSLicenceNumber}
                    />
                  </div>
                </div>
              </div>
            </li>
            }
          </ol>
        </div>

        <div className="row">
          <div className={"col-lg-4" + applicationSaveError ? " has-error" : ""}>
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={"Save and next"}
              onClick={() => {
                // setting this flag will make the application elibigle for the payment.
                // this flag will be set true in the "confirmation" screen for the
                // individual broker and associate broker
                // dispatch(
                //   setMortgageProperty({
                //     key: MORTGAGE_APPLICATION_PROPERTY,
                //     value: true
                //   })
                // );

                dispatch(setMainAgentRetentionApplicationForApproval());

                dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
                  .then(() => {
                    // dispatch(
                    //   push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_PAYMENT_PREVIEW}`)
                    // );
                    dispatch(
                      push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_MAIN_AGENT_CHANGE_REQUEST_SUBMIT_CONFIRM}`)
                    );
                  })
                  .catch(() => {
                    setApplicationSaveError(true);
                  });
              }}
            />
            {applicationSaveError && ErrorMark()}
            {applicationSaveError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        appElement={document.getElementById("root")}
        isOpen={showEditDialog}
        contentLabel="editDetailsDialog"
        onRequestClose={() => {
          setShowEditDialog(false);
        }}
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
        className="modalDialogContent editDetailsModalDialog"
        closeTimeoutMS={150}
      >
        <div className="row">
          <div className="col-11">
            <div className="row">
              <div className="col-12">
                <h2>{titleForComponent(editComponent)}</h2>
                <MainSeparator />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {editComponent === COMPONENT_KEYS.APPLICANT_CONTACT && (
                  <AgentContactInformation
                    isModal
                    viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                    onEditSave={() => setShowEditDialog(false)}
                    {...props}
                  />
                )}
              </div>
            </div>
            {/*
            <div className="row">
              <div className="col-12">
                {editComponent === COMPONENT_KEYS.CURRENT_MORTGAGE_LICENCE ? (
                  previouslyLicencedStatus === LICENCED_EXEMPT ? (
                    <MainAgentUploadWorkHistory
                      isModal
                      viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                      onEditSave={() => setShowEditDialog(false)}
                    />
                  ) : mblraLicenceNumber ? (
                    <MainAgentLicenceNumber
                      isModal
                      viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                      onEditSave={() => setShowEditDialog(false)}
                      {...props}
                    />
                  ) : (
                    <MainAgentMortgageBrokerInfo
                      isModal
                      viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                      onEditSave={() => setShowEditDialog(false)}
                    />
                  )
                ) : null}
              </div>
            </div>
            */}
            <div className="row">
              <div className="col-12">
                {editComponent === COMPONENT_KEYS.CRC_DOCUMENT_UPLOAD && (
                  <MainAgentCriminalRecordCheckUpload
                    isModal
                    viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                    onEditSave={() => setShowEditDialog(false)}
                    {...props}
                  />
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {editComponent === COMPONENT_KEYS.CURRENT_NS_LICENCE && (
                  <MainAgentNSLicenceNumber
                    isModal
                    viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                    onEditSave={() => setShowEditDialog(false)}
                    {...props}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="col-1">
            <div
              className="closeButton pull-right"
              onClick={() => {
                setShowEditDialog(false);
              }}
            >
              <i className="fa fa-2x fa-times"></i>
            </div>
          </div>
        </div>
      </Modal>

      <DocumentViewer
        fileData={documentViewerDocument}
        fileName={selectedFile?.filename}
        isOpen={openDocumentViewer}
        handleClose={() => setOpenDocumentViewer(false)}
      />
    </>
  );
};
